import { useEffect } from "react";
import image1 from '../assets/image/image1.png';
import image2 from '../assets/image/image2.png';
import image3 from '../assets/image/image3.png';
import image4 from '../assets/image/image4.png';
import image5 from '../assets/image/image5.png';
import image6 from '../assets/image/image6.png';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const Gallery = ({ MarginTop }) => {
    const images = [image1, image2, image3, image4, image5, image6];

    useEffect(() => {
        Fancybox.bind('[data-fancybox="gallery"]', {
            Toolbar: {
                display: [
                    "slideshow",
                    "thumbs",
                    "zoom",
                    "fullscreen",
                    "close",
                ],
            },
        });

        return () => {
            Fancybox.destroy();
        };
    }, []);

    return (
        <section id="productScreenshots" style={{ scrollMarginTop: MarginTop }}>
            <div className='home-section our_services_sec'>
                <div className="title-section">
                    <h1 className="head-title">Our <span>Product</span> Screenshots</h1>
                    <span className="title-under-line"></span>
                    <p className="title-disc">End-to-end loan processing with integrated underwriting, approval workflows, and disbursement management.</p>
                </div>
                <div className="gallery">
                    {images.map((image, index) => (
                        <div className="card" key={index}>
                            <div className="card-image">
                                <a
                                    href={image}
                                    data-fancybox="gallery"
                                    data-caption={`Image ${index + 1}`}
                                >
                                    <img src={image} alt={`Gallery ${index + 1}`} />
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
export default Gallery;